import { render, staticRenderFns } from "./DeliveryCutOff.vue?vue&type=template&id=61b48624&"
import script from "./DeliveryCutOff.vue?vue&type=script&lang=js&"
export * from "./DeliveryCutOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports